/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum Controls {
  WebCommonHeaderSignOutButton = 'Web_Common_HeaderSignOutButton',
  WebAppointmentTakeScreenshotButton = 'Web_Appointment_TakeScreenshotButton',
  WebAppointmentSharedFiles = 'Web_Appointment_SharedFiles',
  WebAreaStart = 'Web_Area_Start',
  WebAppointmentShareScreenButton = 'Web_Appointment_ShareScreenButton',
  WebIcdOutcomeInput = 'Web_ICD_Outcome_Input',
  WebAppointmentCloseAfterCallButton = 'Web_Appointment_CloseAfterCallButton'
}
